import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ElciaCard } from '../../../../components/card/card';
import { TimesheetSettingsType } from './components/timesheet-settings-type/timesheet-settings-type';
import { TimesheetSettingsStatus } from './components/timesheet-settings-status/timesheet-settings-status';
import {
  TimesheetSettingsActivityType
} from './components/timesheet-settings-activity-type/timesheet-settings-activity-type';
import { TimesheetTypeQueryService } from '../../../timesheets/services/timesheet-type-query.service';
import { TimesheetTypeCommandService } from '../../../timesheets/services/timesheet-type-command.service';
import { TimesheetStatusQueryService } from '../../../timesheets/services/timesheet-status-query.service';
import { TimesheetStatusCommandService } from '../../../timesheets/services/timesheet-status-command.service';
import { ActivityTypeQueryService } from '../../../timesheets/services/activity-type-query.service';
import { ActivityTypeCommandService } from '../../../timesheets/services/activity-type-command.service';

@Component({
  selector: 'elcia-timesheet-settings',
  imports: [ElciaCard, TranslateModule, TimesheetSettingsType, TimesheetSettingsStatus, TimesheetSettingsActivityType],
  providers: [
    TimesheetTypeQueryService,
    TimesheetTypeCommandService,
    TimesheetStatusQueryService,
    TimesheetStatusCommandService,
    ActivityTypeQueryService,
    ActivityTypeCommandService,
  ],
  templateUrl: './timesheet-settings.html',
  styleUrl: './timesheet-settings.scss',
})
export class TimesheetSettings {

}
